import { request } from '@/lib/api.ts';

export function updateUserLanguage(userId: number, language: string, token: string) {
    return request(`/api/users/${userId}`, {
        body: {
            language: `/api/public/languages/${language}`,
        },
        token,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/merge-patch+json',
        },
    });
}
